module.exports = __webpack_public_path__ + "img/undraw_pay_online_b-1-hk.1168aca4.svg";